'use client';

import { css } from '@linaria/core';

export const drawer = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const item = css`
  span {
    display: initial !important;
  }
`;

export const discoverAccordion = css`
  && {
    label {
      padding-left: 0;
      padding-right: 0;
      border-top: none;
    }
  }
`;

export const discoverAccordionContent = css`
  display: flex;
  gap: 1rem;
  flex-direction: column;
`;
